import axios from "axios";
import store from "@/store";
import router from "@/router";
import { getToken } from "@/utils/util";
import Vue from "vue";
import qs from "qs";
import { Modal, Message } from "iview";

Vue.prototype.$qs = qs;

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 1000000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token--为自定义key 请根据实际情况自行修改
      config.headers["token"] = getToken();
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data || response;
    if (res.code === 106 || res.code === 107 || res.code === 108) {
      store.dispatch("handleLogOut", "token").then(() => {
        // 跳到登录界面
        router.push("/login");
      });
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject("error");
    } else if (res.code === 0) {
      return Promise.resolve(response);
      Message.error({
        content: res.msg,
        duration: 5,
        closable: true
      });
      return Promise.resolve(res.msg);
    } else if (res.code !== 1) {
      // 非5xx的错误属于业务错误，留给具体页面处理
      return Promise.resolve(response);
    } else {
      return response;
    }
  },
  error => {
	  if(!error||error==undefined||error.toString().indexOf('Network Error')!=-1){
		console.error('系统处理失败，请重试');
		return {"data":{"code":-98,"msg":"系统错误，请重试"}};
	  }
	  if (error.code === 'ECONNABORTED') {
		console.error('请求超时，请检查网络或重试');
		return {"data":{"code":-99,"msg":"请求超时，请重试"}};
	  }
    if (error.response) {
      if (error.response.status === 500) {
		console.error('系统错误');
        Message.error({
          content: '系统错误',
          duration: 5,
          closable: true
        });
		return {"data":{"code":500,"msg":"系统错误"}};
	  }
      if (error.response.status === 401) {
        switch (error.response.status) {
          case 401:
            Modal.error({
              title: "错误",
              content: "系统未登录，请重新登录",
              onOk: () => {
                store.dispatch("FedLogOut").then(() => {
                  // 跳到登录界面
                  router.push("/login");
                });
              }
            });
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject("error");
        }
      } else {
        Message.error({
          content: error.response.msg,
          duration: 5,
          closable: true
        });
        return Promise.reject(error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js